import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#3f4e3a", color: "white" }} className="py-5 mt-5 border-top">
      <div className="container">
        <div className="row text-center text-sm-start">
          <div className="col-12 col-sm-4 mb-4 mb-sm-0">
            <h5 className="mb-3 fw-bold text-white text-decoration-underline">Company</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-white text-decoration-none">About Us</a></li>
              <li><a href="/" className="text-white text-decoration-none">Careers</a></li>
              <li><a href="/" className="text-white text-decoration-none">Blog</a></li>
              <li><a href="/" className="text-white text-decoration-none">Terms & Conditions</a></li>
              <li><a href="/" className="text-white text-decoration-none">Privacy Policy</a></li>
            </ul>
          </div>
          <div className="col-12 col-sm-4 mb-4 mb-sm-0">
            <h5 className="mb-3 fw-bold text-white text-decoration-underline">Contact</h5>
            <address className="text-white">
              AL244, Ground Floor, Saltlake sector 2,<br />
               Kolkata, India<br />
              <i className="bi bi-telephone-fill me-2"></i>
              <a href="tel:+911234567890" className="text-white text-decoration-none">+91 9836904698</a><br />
              <i className="bi bi-envelope-fill me-2"></i>
              <a href="mailto:info@home-saloon.com" className="text-white text-decoration-none">info@orrbiit.com</a>
            </address>
          </div>
          <div className="col-12 col-sm-4">
            <h5 className="mb-3 fw-bold text-white text-decoration-underline">Social</h5>
            <div className="d-flex justify-content-center justify-content-sm-start gap-3 fs-4">
              <a href="/" className="text-white"><i className="bi bi-facebook"></i></a>
              <a href="/" className="text-white"><i className="bi bi-twitter"></i></a>
              <a href="/" className="text-white"><i className="bi bi-instagram"></i></a>
              <a href="/" className="text-white"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>
        </div>
        <hr className="my-4 border-white" />
        <div className="text-center py-2 mt-3" style={{ fontSize: "0.875rem", backgroundColor: "#2c2c2c" }}>
          © {new Date().getFullYear()} Orrbiit. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
